<template>
  <section class="" id="newsletters-section">
    <h1 class="title">{{$resx('NewslettersTitleText')}}</h1>
    <h2 class="subtitle">{{$resx('NewslettersSubtitleText')}}</h2>
    <div class="rules">
      <div class="can">
        <i class="material-icons text-succes">sentiment_satisfied</i><h3>{{$resx('NewslettersYouCanTitleText')}}</h3>
        <span v-html="$resx('NewslettersYouCan1Text')"></span>
        <strong>+</strong>
        <span v-html="$resx('NewslettersYouCan2Text')"></span>
      </div>
      <div class="cannot">
        <i class="material-icons text-error">sentiment_dissatisfied</i><h3>{{$resx('NewslettersYouCantTitleText')}}</h3>
        <span v-html="$resx('NewslettersYouCant1Text')"></span>
      </div>
    </div>
    <span class="choice text-center">{{$resx('PepiteChoiceText')}}</span>
    <table class="mytable">
      <caption class="text-right">
        <select class="select" v-model="currentYear">
          <option v-for="year in years" :value="year" :key="year">{{year}}</option>
        </select>
      </caption>
      <thead>
        <tr>
          <th>{{$resx('NewslettersTableHeader1Text')}}</th>
          <th>{{$resx('NewslettersTableHeader2Text')}}</th>
          <th>{{$resx('NewslettersTableHeader3Text')}}</th>
          <th>{{$resx('PepiteTableHeader7Text')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in newsletters" :class="{selected : item.booked}" :key="item.id">
          <td>{{item.formatedDate}}</td>
          <td>{{item.label}}</td>
          <td><img class="flag" :src="getFlag(item.language)" />{{item.language}}</td>
          <td>
            <span v-if="isMaxReached && !item.booked">{{$resx('NewslettersMaxReachedText')}}</span>
            <div class="selector" v-if="! isMaxReached && !item.booked " :class="{disabled : !item.isSelectable}">
              <button class="fake-checkbox" @click="bookNewsletter(item)" :id="'chkSelect-'+item.id"></button><label :for="'chkSelect-'+item.id">{{$resx('NewslettersChooseText')}}</label>
            </div>
            <div class="selector" v-if="item.booked" :class="{disabled : !item.isSelectable}">
              <button class="fake-checkbox checked" @click="cancelNewsletter(item)" :id="'chkCancel-'+item.id"></button><label :for="'chkCancel-'+item.id">{{$resx('NewslettersCancelText')}}</label>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="isLoading">
        <tr>
          <td colspan="4" class="text-center">
            <i class="loading material-icons">cached</i>
          </td>
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
import newsletterServices from '../services/newsletterServices'
var moment = require('moment')

export default {
  data () {
    return {
      newsletters: [], // liste des newsletters
      maxAllowed: 0, // nb max selection autorisée
      isLoading: false,
      currentYear: 2019,
      years: [] // liste des années dispo
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },
    // newsletters sélectionnées
    nbSelected () {
      return this.newsletters.filter(x => !x.isAutoAffected && x.booked).length
    },
    // newsletters restantes à sélectionner
    nbRemaining () {
      return this.maxAllowed - this.nbSelected
    },
    // le quota de sélection est il atteint
    isMaxReached () {
      return this.nbSelected >= this.maxAllowed
    },
    // est ce qu'on peut afficher la page Faq
    canShowNewsletter () {
      return this.$store.getters['app/canShowNewsletter']
    }
  },
  watch: {
    // détecter un changement de camping
    currentCampingId: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadNewsletters()
      }
    },

    // détecter changement d'année
    currentYear: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadNewsletters()
      }
    }
  },
  methods: {
    // charge la liste des semaines
    loadNewsletters () {
      var self = this
      this.newsletters = []
      this.isLoading = true
      newsletterServices.loadList(this.currentCampingId, this.currentYear)
        .then(response => {
          self.isLoading = false
          self.newsletters = response.newsletters
          self.maxAllowed = response.maxAllowed
        })
        .catch(error => {
          self.isLoading = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },

    // sélectionner une newsletter
    bookNewsletter (newsletter) {
      var self = this
      newsletterServices.book(this.currentCampingId, newsletter.id)
        .then(response => {
          if (response.data) {
            newsletter.booked = true
            const message = self.$resx('NewslettersBookedText', [self.nbRemaining])
            self.$store.commit('app/showSnack', { type: 'success', message: message })
          } else {
            const message = self.$resx('UnexpectedErrorText')
            self.$store.commit('app/showSnack', { type: 'error', message: message })
          }
        })
        .catch(error => {
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },

    // annuler la sélection d'une newsletter
    cancelNewsletter (newsletter) {
      var self = this
      newsletterServices.cancel(this.currentCampingId, newsletter.id)
        .then(response => {
          if (response.data) {
            newsletter.booked = false
            const message = self.$resx('NewslettersCancelledText', [self.nbRemaining])
            self.$store.commit('app/showSnack', { type: 'success', message: message })
          } else {
            const message = self.$resx('UnexpectedErrorText')
            self.$store.commit('app/showSnack', { type: 'error', message: message })
          }
        })
        .catch(error => {
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },

    // Affiche le drapeau correspondant à la langue
    getFlag (lang) {
      let country = ''

      switch (lang) {
        case 'EN':
          country = 'gb'
          break

        default:
          country = lang
          break
      }
      return 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + country.toLowerCase() + '.svg'
    },

    // initialisation des années possible et de l'année de départ
    initYears () {
      const now = moment()
      this.currentYear = moment().year()
      const currentMonth = moment().month()

      let dt = moment().year(2018)
      do {
        dt = dt.add(1, 'year')
        this.years.push(dt.year())
      } while (now.isAfter(dt))
      if (currentMonth >= 8) {
        this.years.push(this.currentYear + 1)
      }
    }
  },
  mounted: function () {
    if (this.canShowNewsletter) {
      this.$store.commit('app/setPage', 'newsletters')
      this.initYears()
      this.loadNewsletters()
    } else {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="less">
  @import '../assets/variables.less';

  #newsletters-section
  {
  .choice {
    display: block;
    color: @grey9;
    font-weight: @fontBlack;
    font-size: 3em;
    padding-bottom: 1em;
  }

  .rules
  {
    text-align:center;
    max-width:32em;
    margin:0 auto;

    >div
    {
      margin:2em auto;
    }

    i
    {
      display:inline-block;
      vertical-align:sub;
      margin-right:.5em;
      font-style:normal;
    }

    h3
    {
      font-size:1.5em;
      font-weight: fontBlack;
      color: @grey9;
      text-transform:uppercase;
      margin:.5em auto;
      display:inline-block;
    }

    span,strong, small
    {
      display:block;
      color:@dark;
    }

    small
    {
      margin-top:1em;
    }
  }

  .flag
  {
    width:16px;
    height:16px;
    border-radius:50%;
    vertical-align:bottom;
    margin-right:.5em;
  }

    table
    {
      caption
      {
        margin-bottom: .5em;

        select
        {
          margin-right:0;
          max-width:10em;
        }
      }

      thead
      {
        th
        {
          &:nth-child(1)
          {
            width: 8em;
          }
          &:nth-child(2) {
            width: auto;
          }
          &:nth-child(3) {
            width: 8em;
          }
          &:nth-child(4) {
            width: 16em;
          }
        }
      }
      tbody
      {
        td
        {
          &:nth-child(3)
          {
            text-align:center;
          }
        }
      }
    }
  .selector {
    button
    {
      margin-right: .75em;
      width: .8em;
      height: .8em;
      position: relative;
      padding:0;

    &.checked:after {
    content: '\2713';
    color: @dark;
    font-size: .7em;
    font-weight: @fontBlack;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    }
  }

    input
  {
    cursor: pointer;
    vertical-align: bottom;
    margin-right: .75em;
  }
  label {
    cursor: pointer;
    text-decoration: underline;
  }

    &.disabled
    {
      pointer-events:none;
      cursor:default;
      opacity:.5;

        label
        {
          text-decoration:line-through;
        }
    }
  }
  }
</style>
